<template>
  <v-select
    :value="value"
    :label="label"
    :options="options"
    :multiple="multiple"
    :disabled="disabled"
    :class="classesArray"
    :reduce="reduce"
    :loading="loading"
    :placeholder="placeholder"
    :filterable="false"
    :close-on-select="closeOnSelect"
    :get-option-label="getOptionLabel"
    @search="handleSearch"
    @input="$emit('update:value', $event)"
    @search:focus="searchFocus"
    @option:deselected="$emit('option:deselected', $event)"
  >
    <template #list-footer>
      <div ref="loadMore" v-b-visible="loadMore"></div>
    </template>
  </v-select>
</template>
<script>

import {BFormCheckbox} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {selectData} from "@/api/utils";
import {VBVisible} from 'bootstrap-vue'

export default {
  directives: {
    'b-visible': VBVisible
  },
  components: {
    vSelect, BFormCheckbox
  },
  props: {
    value: [Array, Number, String, Object],
    multiple: Boolean,
    disabled: Boolean,
    classes: {
      type: Array,
      default: () => []
    },
    searchType: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Please select...'
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    reduce: {
      type: Function,
      default: (i) => i.id
    },
    additionParams: {
      type: Object,
      default: () => {}
    },
    isInvalid: {
      type: [Boolean, Number],
      default: false
    },
    label: {
      type: String,
      default: 'text'
    },
    getOptionLabel: {
      type: Function,
      default(option) {
        return option[this.label]
      }
    }
  },
  data(){
    return {
      localValue: this.value ? JSON.parse(JSON.stringify(this.value)) : [],
      options: [],
      page: 1,
      more: true,
      searchQuery: '',
      loading: false,
    }
  },
  computed:{
    params(){
      return {
        type: this.searchType,
        search: this.searchQuery,
        page: this.page,
        addition: this.additionParams
      }
    },
    classesArray(){
      return [
        ...this.classes,
        {'is-invalid': this.isInvalid}
      ]
    }
  },
  methods: {
    async loadOptions(loadMore = false){
      if (!this.more) return

      this.loading = true
      try {

        const {results, pagination } = await selectData(this.params)

        this.options = results;
        this.more = pagination.more
        this.loading = false

      } catch (e){
        this.loading = false
      }
    },

    handleSearch(query) {
      this.searchQuery = query
      this.more = true
    },

    async loadMore(visible) {
      if (!this.more || !visible)  return

      this.page = this.page + 1

      const scrollTop = this.$refs.loadMore.offsetParent.scrollTop

      try {
        const {results, pagination } = await selectData(this.params)

        this.options.push(...results);
        this.more = pagination.more

        await this.$nextTick();
        this.$refs.loadMore.offsetParent.scrollTop = scrollTop;

      } catch (e){

      }
    },
    searchFocus(){
      if (!this.options.length && !this.loading) {
        this.loadOptions()
      }
    }
  },
  watch: {
    searchQuery: function (){
      this.page = 1
      this.loadOptions()
    },
    value: function (val) {
      if (!val){
        this.localValue = null
      }
    }
  }
}
</script>